export default class CostCenter {
  id: string;

  name: string;

  businessUnit: number;

  code: number;

  company: number;

  active: boolean;

  externalId: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.code = obj.email || '';
    this.active = obj.active || '';
    this.company = obj.company || '';
    this.externalId = obj.externalId || '';
    this.businessUnit = obj.businessUnit || '';
  }

  public static of(obj: any): CostCenter {
    return new CostCenter(obj);
  }

  public static ofEmpty(): CostCenter {
    return new CostCenter({});
  }

  public static ofList(members: any): CostCenter[] {
    return members.map((costCenter: any) => new CostCenter(costCenter));
  }
}
